export const faces = [
  // --- 經典表情 ---
  { char: '😀', name: 'Grinning', nameZh: '露齒笑', keywords: ['smile', 'happy', '笑', '開心'] },
  { char: '😆', name: 'Squinting', nameZh: '哈哈', keywords: ['laugh', 'xd', '瞇眼笑'] },
  { char: '😅', name: 'Sweat Smile', nameZh: '苦笑', keywords: ['nervous', 'sweat', '尷尬', '汗'] },
  { char: '😂', name: 'Joy', nameZh: '哭笑', keywords: ['laugh', 'cry', '哭笑不得'] },
  { char: '🥰', name: 'Hearts Face', nameZh: '充滿愛', keywords: ['love', 'cute', '幸福', '心動'] },
  { char: '😍', name: 'Heart Eyes', nameZh: '眼冒愛心', keywords: ['love', 'like', '心動'] },
  { char: '🤩', name: 'Star Eyes', nameZh: '眼冒星星', keywords: ['wow', 'amazing', '崇拜', '閃耀'] },
  { char: '😎', name: 'Cool', nameZh: '酷', keywords: ['sunglasses', 'swag', '質感'] },
  { char: '🥳', name: 'Party', nameZh: '慶祝', keywords: ['celebrate', 'fun', '派對'] },
  { char: '🥺', name: 'Pleading', nameZh: '拜託', keywords: ['beg', 'please', '無辜', '可憐'] },
  { char: '😭', name: 'Sob', nameZh: '大哭', keywords: ['sad', 'cry', '大哭', '激動'] },
  
  // --- 最新趨勢 (2024-2025) ---
  { char: '🫠', name: 'Melting Face', nameZh: '融化', keywords: ['hot', 'melt', '心軟', '好熱'] },
  { char: '🫡', name: 'Salute', nameZh: '敬禮', keywords: ['respect', 'ok', 'yes', '收到', '遵命'] },
  { char: '🫣', name: 'Peeking', nameZh: '偷看', keywords: ['shy', 'scared', '害羞', '偷看'] },
  { char: '🫢', name: 'Hand Over Mouth', nameZh: '驚訝', keywords: ['shock', 'oops', '天啊'] },
  { char: '🫨', name: 'Shaking Face', nameZh: '震動', keywords: ['shake', 'shock', '震驚', '地震', '抖'] },
  { char: '🥹', name: 'Holding Back Tears', nameZh: '感動', keywords: ['proud', 'cry', '想哭', '忍住淚水'] },
  { char: '🫥', name: 'Dotted Line Face', nameZh: '透明人', keywords: ['invisible', 'quiet', '消失', '邊緣'] },
  { char: '🫤', name: 'Diagonal Mouth', nameZh: '撇嘴', keywords: ['confused', 'meh', '無奈'] },
  
  // --- 未來預覽 (Unicode 16.0+) ---
  { char: '🫩', name: 'Face with Bags Under Eyes', nameZh: '熬夜臉', keywords: ['tired', 'sleepy', 'work', '累', '黑眼圈', '加班'] },
  { char: '🙂‍↔️', name: 'Head Shaking Horizontally', nameZh: '搖頭', keywords: ['no', 'refuse', '拒絕', '不'] },
  { char: '🙂‍↕️', name: 'Head Shaking Vertically', nameZh: '點頭', keywords: ['yes', 'agree', '好的', '對'] },
];